import { Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useRef, useState } from "react";

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: { maxWidth: 360, overflowWrap: "anywhere", whiteSpace: "normal" },
  },
};

// `noWrap` sets text-overflow but leaves display alone, and an ellipsis only
// applies to a block container. Without this an inline `component` (such as a
// link) renders the value in full and measures as if it always fits.
const ClippedTypography = styled(Typography)({
  display: "block",
  maxWidth: "100%",
});

const TruncatedText = ({ children, ...props }) => {
  const textRef = useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip
      onClose={() => setIsTooltipOpen(false)}
      onOpen={() => {
        const node = textRef.current;
        setIsTooltipOpen(node != null && node.scrollWidth > node.clientWidth);
      }}
      open={isTooltipOpen}
      slotProps={TOOLTIP_SLOT_PROPS}
      title={children}
    >
      <ClippedTypography noWrap ref={textRef} {...props}>
        {children}
      </ClippedTypography>
    </Tooltip>
  );
};

TruncatedText.propTypes = {
  children: PropTypes.node,
};

export default TruncatedText;
